import { Box, Flex, Container, Link, Button, Image } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const Navbar = () => {
  return (
    <Box as="nav" bg="white" boxShadow="sm" position="sticky" top={0} zIndex="sticky">
      <Container maxW="container.xl">
        <Flex h={16} alignItems="center" justifyContent="center" py={{ base: 4, md: 0 }}>
          <Flex alignItems="center" gap={4}>
            <Image src="/header.png" alt="Logo institucional" height="45px" width="45px" objectFit="contain" />
            <Link as={RouterLink} to="/" fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold" color="blue.600">
              Departamento de Formación Continua
            </Link>
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};

export default Navbar;